import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Collapse,
    Box,
    Typography,
    TextField,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    TablePagination,
    Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../../Utility/API/Serviceurls";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import Loader from "../../../../../Components/Loader";
import { CommonPatientDetails, ReasonPopup } from "../../../../../Components/Common Components/CommonComponents";
import CommonDatePicker from "../../../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";
import { localGetItem } from "../../../../../Utility/Services/CacheProviderService";
import { Colors } from "../../../../../Styles/Colors";
import { ImagePaths } from "../../../../../Utility/ImagePaths";

const LabCancelledOrder = () => {
    const [ordersList, setOrdersList] = useState([]);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const [loginInfo, setLoginInfo] = useState(loggedInUserInfo)
    const [isloader, setisloader] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedRow, setselectedRow] = useState(null);
    const [anchorEl, setanchorEl] = useState(null);
    const [expandedRows, setExpandedRows] = useState({});
    const [orderCount, setorderCount] = useState({});

    const [filters, setFilters] = useState({ patientName: '', patientType: '', fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), dateIndex: 1 });

    useEffect(() => {
        getPendingOrdersList()
    }, [filters?.patientType, filters?.fromDate, filters?.toDate, filters?.dateIndex])


    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    // Pagination Handlers
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredOrders = ordersList.filter((data) => {
        return (
            (data?.patient_name === null ? null : data?.patient_name?.toLowerCase()?.includes(filters?.patientName?.toLowerCase())) ||
            (data?.order_number === null ? null : data?.order_number?.toLowerCase()?.includes(filters?.patientName?.toLowerCase()))
        );
    })

    const paginatedOrders = filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const getPendingOrdersList = () => {
        try {
            setisloader(true)
            let ApiUrl = loginInfo.module_name === "Radiology" ? Serviceurls.PENDING_ORDER_LIST_RAD : (localGetItem('is_investigation_module') === "true") ? Serviceurls.PENDING_ORDER_LIST_INVESTIGATION : Serviceurls.PENDING_ORDER_LIST_LAB;
            RestAPIService.getAll(ApiUrl + `?patient_type=${filters?.patientType ? filters?.patientType : "op,ip,self"}&from_date=${filters?.fromDate}&to_date=${filters?.toDate}&status=Cancelled`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setOrdersList(response.data.data || [])
                        setorderCount(response?.data?.counts || {})
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const FilterDate = (from, to, index) => {
        setFilters((prev) => ({
            ...prev,
            fromDate: from,
            toDate: to,
            dateIndex: index
        }))
    }

    const toggleRow = (orderId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [orderId]: !prev[orderId]
        }));
    };

    const renderCard = (img, label, count = 0) => {
        const countStr = String(count);

        // Dynamic font size: shrink when digits exceed 10
        const fontSize = countStr.length > 13 ? '0.7rem' : '0.9rem';

        return (
            <Paper component={'div'} sx={{ width: "10vw", display: 'flex', alignItems: 'center' }}>
                <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'}>
                    <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box component={'img'} src={img} marginLeft={'.2vw'} height={'5dvh'} width={'2.3dvw'} />
                    </Box>

                    <Box component={'div'}>
                        <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{label}</Typography>

                        {/* Wrap count with tooltip */}
                        <Tooltip title={countStr.length > 13 ? countStr : ""}>
                            <Typography
                                fontSize={fontSize}
                                fontWeight={600}
                                sx={{ cursor: countStr.length > 13 ? "pointer" : "default" }}
                            >
                                {count}
                            </Typography>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>
        );
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', marginRight: ".2vw", mt: loginInfo?.module_name === 'Radiology' ? "1vw" : "0vw" }}>
                <Box flex={0.5} display={'flex'} justifyContent={'space-between'} >
                    {renderCard(ImagePaths.TotalOrders.default, 'Total Orders', orderCount?.total_count || 0)}
                    {renderCard(ImagePaths.TotalOP.default, 'Total OP Orders', orderCount?.op || 0)}
                    {renderCard(ImagePaths.TotalIP.default, 'Total IP Orders', orderCount?.ip || 0)}
                    {renderCard(ImagePaths.TotalSelf.default, 'Total Self Orders', orderCount?.lab_self || 0)}
                </Box>
                <Box flex={0.5} sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "1vw" }}>
                    <TextField
                        size='small'
                        fullWidth
                        sx={{ width: "15dvw", mr: "1vw" }}
                        value={filters?.patientName || ""}
                        onChange={(e) => {
                            setFilters((prev) => ({ ...prev, patientName: e.target.value }))
                        }}
                        label={"Search Patient Name / Order No"}
                        autoComplete='off'
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && e.target.value !== '' && e.target.value?.length > 4) {
                            }
                        }}
                    />
                    <FormControl sx={{ width: '15dvw', mr: "1vw" }} size='small'>
                        <InputLabel>Patient Type</InputLabel>
                        <Select
                            label='Patient Type'
                            value={filters.patientType}
                            onChange={(e) => {
                                setFilters((prev) => ({ ...prev, patientType: e.target.value }))
                            }}
                        >
                            <MenuItem value={''}>All</MenuItem>
                            <MenuItem value={'op'}>OP</MenuItem>
                            <MenuItem value={'ip'}>IP</MenuItem>
                            <MenuItem value={'self'}>Self</MenuItem>
                        </Select>
                    </FormControl>
                    <Box className='eMed_IP_AptDateFlt'>
                        <CommonDatePicker
                            FromDate={filters?.fromDate}
                            ToDate={filters?.toDate}
                            DateIndex={filters?.dateIndex}
                            SelectedDates={FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                </Box>

            </Box>
            <TableContainer component={Paper} style={{ padding: "10px", height: "58.5dvh" }}>
                <Table size='small'>
                    <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                        <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Patient Details</TableCell>
                            {loginInfo?.module_name === "Laboratory" ? <TableCell>Doctor Name</TableCell> : null }
                            <TableCell>Order Details</TableCell>
                            <TableCell>OP / IP Number</TableCell>
                            <TableCell>No of Services</TableCell>
                            <TableCell>Created By</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {paginatedOrders?.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedOrders.map((row, index) => {
                                const roomName = `${row?.bed_number || ''}/${row?.room_number || ''}/${row?.ward_name || ''}/${row?.block_name|| ''}`
                                return (
                                <React.Fragment key={row.id}>
                                    {/* Parent Row */}
                                    <TableRow>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <Box>
                                                <CommonPatientDetails disablePhoto={true} data={row} />
                                            </Box>
                                        </TableCell>
                                        {loginInfo?.module_name === "Laboratory" ? 
                                        <TableCell>
                                                <Box>
                                                    {row?.doctor_name ? row?.doctor_name?.length > 20 ?
                                                        <Tooltip placement="top" title={row?.doctor_name}>
                                                            <Typography fontSize={'0.9vw'}>{row?.doctor_name?.slice(0, 20) + '...'}</Typography>
                                                        </Tooltip> :
                                                        <Typography fontSize={'0.9vw'}>{row?.doctor_name || "-"}</Typography> : '-'}
                                                    {
                                                        row?.is_ip ?
                                                            roomName?.length > 20 ?
                                                                <Tooltip placement="top" title={roomName}>
                                                                    <Typography fontSize={'0.9vw'}>{roomName?.slice(0, 20) + '...'}</Typography>
                                                                </Tooltip> :
                                                                <Typography fontSize={'0.9vw'}>{roomName}</Typography> || '-' : null
                                                    }
                                                </Box>
                                        </TableCell> : null}
                                        <TableCell>{row.order_number ? row.order_number : "-"}</TableCell>
                                        <TableCell>{row.module_number ? row.module_number : "-"}</TableCell>
                                        <TableCell>{row.pending_line_count ? row.pending_line_count : "-"}</TableCell>
                                        <TableCell>
                                            {row.created_by ? row.created_by : "-"}
                                            <IconButton onClick={() => toggleRow(row.order_id)}>
                                                {expandedRows[row.order_id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    {/* Expandable Child Row */}
                                    < TableRow >
                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                            <Collapse in={!!expandedRows[row.order_id]} timeout="auto" unmountOnExit>
                                                <Table size="small" style={{ marginBottom: "10px" }}>
                                                    <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                                        <TableRow>
                                                            <TableCell>S No</TableCell>
                                                            <TableCell>Service Name</TableCell>
                                                            <TableCell>Service Head</TableCell>
                                                            <TableCell>Doctor Name</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {row?.order_line_items && row?.order_line_items.map((item, i) => (
                                                            <TableRow key={i}>
                                                                <TableCell>{i + 1}</TableCell>
                                                                <TableCell>{item.service_name ? item.service_name : "-"}</TableCell>
                                                                <TableCell>{item.service_head_name ? item.service_head_name : "-"}</TableCell>
                                                                <TableCell>{item.bill_doctor_name ? item.bill_doctor_name : "-"}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                                )}
                            )) }
                    </TableBody>
                </Table>
            </TableContainer>
             {/* Pagination Component */}
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredOrders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {
                message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {
                message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {isloader ? <Loader loaderOpen={isloader} /> : null}
        </Box >

    );
};

export default LabCancelledOrder;


